// For strings interpolated into HTML-string contents (Syncfusion
// DialogUtility/Popup take HTML, not JSX) — user-provided names must not be
// able to inject markup.
export function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
